import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditBadgePayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IListState {
    status: string
    data: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editBadgeSlice = createSlice({
    name: 'badges/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditBadgePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editBadgeActions = editBadgeSlice.actions
export default editBadgeSlice.reducer
